module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"resultMsg":"No results | One truck | { count } Trucks","for":"for"},"es":{"resultMsg":"Sin resultados | Solo un camión | { count } Camiones","for":"para"}}')
  delete Component.options._Ctor
}
